module.exports = __webpack_public_path__ + "vrsafety/static/media/VRS_asset_360globe_icon.c45f8a9b.png";